module.exports = __webpack_public_path__ + "static/media/make-it-rain.02e9c62f.png";